import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type {
  ExtendedNotificationNoteInitializer,
  ExtendedNotificationNoteMutator,
  NoteId,
} from '@beaded/models'

import * as apiUtils from '.'

const url = '/notification-notes'

export const create = (data: ExtendedNotificationNoteInitializer) =>
  apiUtils.POST(`${url}/`, data)

export const get = (id: NoteId, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/${id}`, merge({}, options))

export const getAll = (options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/`, merge({}, options))

export const update = (id: NoteId, data: ExtendedNotificationNoteMutator) =>
  apiUtils.PUT(`${url}/${id}`, data)

export const remove = (id: NoteId) => apiUtils.DELETE(`${url}/${id}`)
